<button mat-icon-button [matMenuTriggerFor]="sortMenu" [matTooltip]="tooltip$ | async">
  <mat-icon>sort</mat-icon>
</button>
<mat-menu #sortMenu>
  <div *ngIf="value$ | async as value" (click)="$event.stopPropagation()" class="mat-select-panel session-sort-select-panel">
    <mat-optgroup *ngFor="let level of options">
      <mat-label>{{ 'acquisitionSort.' + level.value + '.groupLabel' | translate }}</mat-label>
      <mat-option *ngFor="let option of level.options"
        (click)="selectSortOption(level.value, option.value)"
        [ngClass]="{ selected: value[level.value].active === option.value }">
        <span>{{ 'acquisitionSort.' + level.value + '.' + option.value | translate }}</span>
        <fw-sort-icon *ngIf="value[level.value].active === option.value"
          [field]="option.value"
          [sort]="value[level.value]">
        </fw-sort-icon>
      </mat-option>
    </mat-optgroup>
  </div>
</mat-menu>
